import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Building2, ExternalLink, MapPin, UserRound } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';

const AboutPage = () => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = 'About AEO Orchestra - Solaris Code SL';
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      <Header />
      <main className="pt-28 pb-24 bg-[#0a0a0a] min-h-screen">
        <div className="max-w-4xl mx-auto px-6">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#0055FF]/10 border border-[#0055FF]/20 text-[#0055FF] text-xs font-medium uppercase tracking-wider mb-6">
            <Building2 size={14} /> Solaris Code SL
          </div>

          <h1 className="font-['Outfit'] text-4xl md:text-5xl font-bold text-white tracking-tight leading-tight mb-5">
            AEO Orchestra is built by Solaris Code SL in Tenerife
          </h1>
          <p className="text-lg text-[#C8C8CC] leading-relaxed mb-10">
            AEO Orchestra is a WordPress SEO + AEO product from Solaris Code SL, based in Tenerife,
            Canary Islands, Spain. The product helps agencies, SMEs and publishers make WordPress
            content easier for search engines and answer engines to read, evaluate and cite.
          </p>

          <section className="grid md:grid-cols-2 gap-5 mb-12">
            <div className="bg-[#111111] border border-white/10 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-3 text-white">
                <MapPin className="w-5 h-5 text-[#0055FF]" />
                <h2 className="font-['Outfit'] text-xl font-semibold">Company</h2>
              </div>
              <p className="text-[#A1A1AA] leading-relaxed">
                Solaris Code SL operates AEO Orchestra from Tenerife, Canary Islands, Spain.
                Customer support is available at <a className="text-[#0055FF] hover:underline" href="mailto:support@aeo-orchestra.com">support@aeo-orchestra.com</a>.
              </p>
            </div>

            <div className="bg-[#111111] border border-white/10 rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-3 text-white">
                <UserRound className="w-5 h-5 text-[#0055FF]" />
                <h2 className="font-['Outfit'] text-xl font-semibold">People</h2>
              </div>
              <p className="text-[#A1A1AA] leading-relaxed mb-4">
                James Cappelli works on product direction and engineering for AEO Orchestra.
              </p>
              <a
                className="inline-flex items-center gap-2 text-[#0055FF] hover:text-[#3377FF] font-medium"
                href="/author/jcappelli/"
              >
                James Cappelli author page <ExternalLink size={16} />
              </a>
            </div>
          </section>

          <section className="border-t border-white/10 pt-8">
            <h2 className="font-['Outfit'] text-2xl font-semibold text-white mb-4">What we publish</h2>
            <p className="text-[#A1A1AA] leading-relaxed mb-6">
              We document practical work on WordPress SEO, AEO, llms.txt, schema markup, migration
              from legacy SEO plugins, and AI-assisted editorial workflows. Product claims are framed
              as citation readiness and technical eligibility, not guaranteed rankings or guaranteed
              AI mentions.
            </p>
            <div className="flex flex-wrap gap-3">
              <Link to="/guide" className="px-5 py-2.5 rounded-lg bg-[#0055FF] hover:bg-[#3377FF] text-white font-medium text-sm transition-colors">
                Read guides
              </Link>
              <Link to="/contact" className="px-5 py-2.5 rounded-lg border border-white/15 hover:border-white/30 text-white font-medium text-sm transition-colors">
                Contact Solaris Code SL
              </Link>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default AboutPage;
